import classNames from 'classnames';
import { Star } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { assetUrl } from '../../../Shared/helpers';
import { useLocale } from '../../../Shared/locale';
import { Event, Project } from '../../../Shared/types';
import { Card } from '../../../Shared/UI/Card';
import { Icon } from '../../../Shared/UI/Icon';
import { useRouter } from '../../router';
import EventLogo from './EventLogo';

export default function EventCard({
  event,
}: {
  event: Event & { project: Project | null; };
}) {
  const { t } = useTranslation();
  const { formatDate } = useLocale();
  const { routes } = useRouter();

  return (
    <Card
      spacing="xs"
      link={{ href: routes.event_page(event.id) }}
    >
      <div className={classNames(
        'grid grid-cols-[32px_2fr_2fr_250px_100px] gap-4 items-center',
        event.ended && 'opacity-50'
      )} >
        <div>
          <EventLogo event={event} />
        </div>
        <div className="min-w-0">
          <h4 className={classNames(
            'pr-4 overflow-hidden whitespace-nowrap text-ellipsis',
            event.starred && 'font-bold'
          )}>
            {event.title}
          </h4>
        </div>
        <div className="min-w-0 text-sm">
          <div className="pr-4 overflow-hidden whitespace-nowrap text-ellipsis">
            {formatDate(event.start_date)}
            {' · '}
            {event.organiser}
          </div>
        </div>
        <div className="text-sm">
          {event.fundraising_enabled && (
            <span className="flex items-center space-x-2 text-slate-400">
              <img
                src={assetUrl('images/logo-atleta-symbol.svg')}
                alt="Atleta"
                className="h-3"
              />
              <span>
                {t('backend:fundraising_enabled')}
              </span>
            </span>
          )}
        </div>
        <div className="text-sm font-medium text-right text-blue-500">
          {event.starred && (
            <>
              <Icon className="mr-1">
                <Star />
              </Icon>
              {t('backend:popular')}
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
